import { string, object } from 'yup'

const searchSchema = object({
  query: string()
    .min(2, 'Please enter a valid term')
    .required('Please enter a search term'),
})

export default searchSchema
